import AHRIRelatedProductAddToCartButton from "@crescentParts/Components/AHRIToolRelatedProduct/Components/AHRIRelatedProductAddToCartButton";
import AHRIRelatedProductAddToListLink from "@crescentParts/Components/AHRIToolRelatedProduct/Components/AHRIRelatedProductAddToListLink";
import AHRIRelatedProductContextAvailability from "@crescentParts/Components/AHRIToolRelatedProduct/Components/AHRIRelatedProductContextAvailability";
import AHRIRelatedProductQuantityOrdered from "@crescentParts/Components/AHRIToolRelatedProduct/Components/AHRIRelatedProductQuantityOrdered";
import AHRIRelatedProductUnitOfMeasureSelect from "@crescentParts/Components/AHRIToolRelatedProduct/Components/AHRIRelatedProductUnitOfMeasureSelect";
import AHRIRelatedProductQuantityBreakPricing from "@crescentParts/Components/AHRIToolRelatedProduct/Components/CustomProductQuantityBreakPricing";
import CustomApplicationState from "@crescentParts/Store/CustomApplicationState";
import { getProductInfoFromList } from "@crescentParts/Store/Data/AHRIRelatedProduct/AHRIRelatedProductInfoListSelectors";
import updateRelatedProductInfo from "@crescentParts/Store/Data/AHRIRelatedProduct/Handler/UpdateAHRIRelatedProductInfo";
import useOverlayBadge from "@insite/client-framework/Common/Hooks/useOverlayBadge";
import useWidgetBadges from "@insite/client-framework/Common/Hooks/useWidgetBadges";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import {
    ProductAddToListLinkStyles,
} from "@insite/content-library/Components/ProductAddToListLink";
import { ProductAvailabilityStyles } from "@insite/content-library/Components/ProductAvailability";
import ProductBrand, { ProductBrandStyles } from "@insite/content-library/Components/ProductBrand";
import ProductDescription, { ProductDescriptionStyles } from "@insite/content-library/Components/ProductDescription";
import ProductImage, { ProductImageStyles } from "@insite/content-library/Components/ProductImage";
import ProductImageBadges from "@insite/content-library/Components/ProductImageBadges";
import ProductPartNumbers, { ProductPartNumbersStyles } from "@insite/content-library/Components/ProductPartNumbers";
import ProductPrice, { ProductPriceStyles } from "@insite/content-library/Components/ProductPrice";
import {
    ProductQuantityBreakPricingStyles,
} from "@insite/content-library/Components/ProductQuantityBreakPricing";
import ProductTextBadges from "@insite/content-library/Components/ProductTextBadges";
import Badge from "@insite/mobius/Badge";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import { FormFieldStyle } from "@insite/mobius/FormField";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { SelectPresentationProps } from "@insite/mobius/Select";
import { InputStyle, TextFieldProps } from "@insite/mobius/TextField";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import React, { useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    product?: any;
    showImage: boolean;
    showBrand: boolean;
    showTitle: boolean;
    showPartNumbers: boolean;
    showPrice: boolean;
    showAddToCart: boolean;
    showAddToList: boolean;
    showImageBadges?: boolean;
    maximumNumberOfImageBadges?: number;
    showTextBadges?: boolean;
    maximumNumberOfTextBadges?: number;
    extendedStyles?: RelatedProductCarouselProductStyles;
    showProductAvailability?: boolean;
    showQuantityBreakPricing?: boolean;
    isProductDetailsPage?: boolean;
}
const mapStateToProps = (state: CustomApplicationState, ownProps: OwnProps) => ({
    productInfo: getProductInfoFromList(state, ownProps.product.id) || {
        productId: ownProps.product.id,
        qtyOrdered: 1,
        unitOfMeasure: "",
        productDetailPath: ownProps.product.canonicalUrl,
        pricing: ownProps.product.pricing,
        inventory: ownProps.product.inventory
    },
});

const mapDispatchToProps = {
    updateRelatedProductInfo
};

type Props = OwnProps & ResolveThunks<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>;

export interface RelatedProductCarouselProductStyles {
    productImageStyles?: ProductImageStyles;
    productBrandWrapper?: InjectableCss;
    productBrandStyles?: ProductBrandStyles;
    productDescriptionStyles?: ProductDescriptionStyles;
    productDetailsDescriptionStyles: ProductDescriptionStyles;
    productPartNumbersStyles?: ProductPartNumbersStyles;
    productPriceWrapper?: InjectableCss;
    productUnitOfMeasureSelectStyles?: SelectPresentationProps;
    productQuantityBreakPricingStyles?: ProductQuantityBreakPricingStyles;
    addToCartContainer?: GridContainerProps;
    qtyGridItem?: GridItemProps;
    productQuantityOrderedStyles?: TextFieldProps;
    addToCartButtonGridItem?: GridItemProps;
    productAddToCartButtonStyles?: ButtonPresentationProps;
    productAddToListLinkStyles?: ProductAddToListLinkStyles;
    badgeAreaWrapper?: InjectableCss;
    badgeTextWrapper?: InjectableCss;
    badgeImageWrapper?: InjectableCss;
    badgeText?: TypographyPresentationProps;
    badgeImageProps?: JSX.IntrinsicElements["img"];
    productDetailsAddToListLinkStyles?: ProductAddToListLinkStyles;
    productPriceStyles?: ProductPriceStyles;
    productDetailsPriceStyles?: ProductPriceStyles;
    availabilityStyles?: ProductAvailabilityStyles;
}

export const relatedProductCarouselProductStyles: RelatedProductCarouselProductStyles = {
    productImageStyles: {
        linkWrappingImage: {
            css: css`
                display: flex;
                justify-content: center;
            `,
        },
        img: {
            css: css`
                max-width: 100%;
                max-height: 230px;
                width: auto;
                height: auto;
            `,
        },
    },
    productBrandWrapper: {
        css: css`
            margin: 6px 0;
            min-height: 22px;
        `,
    },
    productBrandStyles: {
        nameLink: {
            typographyProps: {
                variant: "headerTertiary",
                fontFamily: "Hind",
                css: css`
                    text-transform: capitalize;
                `,
            },
        },
    },
    productDescriptionStyles: {
        productDetailLink: {
            typographyProps: {
                variant: "h5",
                color: "text.accent",
                css: css`
                    font-size: 18px !important;
                    margin-bottom: 8px;
                `,
            },
        },
    },
    productDetailsDescriptionStyles: {
        productDetailLink: {
            typographyProps: {
                variant: "h6",
                color: "text.accent",
                css: css`
                    margin-bottom: 8px;
                `,
            },
        },
    },
    productPartNumbersStyles: {
        container: {
            css: css`
                flex-grow: 0;
                margin-bottom: 6px;
            `,
        },
        erpNumberLabelText: { size: 13 },
        erpNumberValueText: { size: 13 },
    },
    productPriceWrapper: {
        css: css`
            flex-grow: 1;
            margin-bottom: 6px;
            margin: 0 0 7px 0;
        `,
    },
    productPriceStyles: {
        price: {
            priceText: {
                css: css`
                    font-size: 14px;
                `,
            },
        },
    },
    productDetailsPriceStyles: {
        price: {
            priceText: {
                css: css`
                    font-size: 20px;
                `,
            },
        },
    },
    productUnitOfMeasureSelectStyles: {
        cssOverrides: {
            formField: css`
                margin-top: 6px;
            `,
        },
    },
    addToCartContainer: {
        gap: 10,
        css: css`
            flex-grow: 0;
            margin-bottom: 6px;
        `,
    },
    qtyGridItem: {
        width: 3,
        css: css`
            > ${FormFieldStyle} {
                ${InputStyle} {
                    &:focus,
                    &:focus-within {
                        border: 2px solid ${getColor("common.border")} !important;
                        border-radius: 6px;
                    }
                }
            }
        `,
    },
    productQuantityOrderedStyles: {
        cssOverrides: {
            formField: css`
                margin-top: 0;
            `,
        },
    },
    addToCartButtonGridItem: { width: 9 },
    productAddToCartButtonStyles: {
        css: css`
            width: 100%;
        `,
    },
    productAddToListLinkStyles: {
        link: {
            typographyProps: { size: 13 },
            css: css`
                margin-bottom: 12px;
            `,
        },
    },
    badgeAreaWrapper: {
        css: css`
            position: relative;
        `,
    },
    badgeTextWrapper: {
        css: css`
            position: absolute;
            width: 50%;
            white-space: nowrap;
            overflow: hidden;
        `,
    },
    badgeImageWrapper: {
        css: css`
            position: absolute;
            width: 25%;
            height: 25%;
        `,
    },
    badgeText: {
        weight: "bold",
        css: css`
            width: 100%;
            margin: auto;
            ${wrapInContainerStyles}
        `,
    },
    productDetailsAddToListLinkStyles: {
        link: {
            css: css`
                margin-top: 5px;
                justify-content: center;
            `,
        },
    },
    productQuantityBreakPricingStyles: {
        viewLink: {
            typographyProps: {
                size: 14,
                weight: 500,
            },
        },
    },
    availabilityStyles: {
        availabilityByWarehouseLink: {
            typographyProps: {
                size: 14,
                weight: 500,
            },
        },
    },
};

const styles = relatedProductCarouselProductStyles;

const AHRIToolRelatedProductInfo = ({
    product,
    productInfo,
    showImage,
    showBrand,
    showTitle,
    showPartNumbers,
    showPrice,
    showAddToCart,
    showAddToList,
    showImageBadges,
    maximumNumberOfImageBadges,
    showTextBadges,
    maximumNumberOfTextBadges,
    showProductAvailability,
    updateRelatedProductInfo
 }: Props) => {
    const productContext: ProductContextModel = {
        product,
        productInfo,
        onUnitOfMeasureChanged: unitOfMeasure => {
            updateRelatedProductInfo({ productId: product.id, unitOfMeasure });
        },
        onQtyOrderedChanged: qtyOrdered => {
            updateRelatedProductInfo({ productId: product.id, qtyOrdered });
        },
    };

    const {
        showOverlayBadge,
        overlayBadge,
        overlayBadgeWrapperStyles,
        badgeAreaWrapperRef,
        overlayBadgeWrapperClickHandler,
    } = useOverlayBadge({
        productContext,
        showTextBadge: showTextBadges,
        showImageBadge: showImageBadges,
        styles,
    });

    const { imageBadges, textBadges } = useWidgetBadges({ productContext, showTextBadges, showImageBadges });

    return (
        <>
            {showImage && !showOverlayBadge && (
                <ProductImage
                    product={productContext}
                    extendedStyles={styles.productImageStyles}
                />
            )}
            {showImage && showOverlayBadge && overlayBadge && (
                    <StyledWrapper
                    {...styles.badgeAreaWrapper}
                    ref={badgeAreaWrapperRef}
                    data-test-selector="productCarouselBadge"
                >
                        <ProductImage extendedStyles={styles.productImageStyles} product={productContext} />
                        <StyledWrapper {...overlayBadgeWrapperStyles} onClick={overlayBadgeWrapperClickHandler}>
                            <Badge
                                type={overlayBadge.badgeType}
                                value={
                                    overlayBadge.badgeType === "Image"
                                        ? overlayBadge.largeImageBadgePath
                                        : overlayBadge.displayText
                                }
                                badgeTextColor={overlayBadge.textColorHexCode}
                                badgeBackgroundColor={overlayBadge.badgeColorHexCode}
                                badgeTextRounding={overlayBadge.badgeStyle === "Round" ? 20 : 0}
                                imageAltText={overlayBadge.imageAltText ? overlayBadge.imageAltText : overlayBadge.name}
                                textBadgeCss={styles.badgeText}
                                imageBadgeProps={styles.badgeImageProps}
                            />
                        </StyledWrapper>
                    </StyledWrapper>
                )}
                {showBrand && product.brand && (
                    <StyledWrapper {...styles.productBrandWrapper}>
                        <ProductBrand brand={product.brand} extendedStyles={styles.productBrandStyles} />
                    </StyledWrapper>
                )}
                {showTitle && (
                    <ProductDescription
                        product={productContext}
                        extendedStyles={styles.productDescriptionStyles}
                    />
                )}
                {showPartNumbers && (
                    <ProductPartNumbers
                        productNumber={product.productNumber}
                        customerProductNumber={product.customerProductNumber}
                        manufacturerItem={product.manufacturerItem}
                        showCustomerName={false}
                        showManufacturerItem={false}
                        extendedStyles={styles.productPartNumbersStyles}
                    />
                )}
                {showTextBadges && textBadges && (
                    <ProductTextBadges badgeList={textBadges} maxBadges={maximumNumberOfTextBadges ?? 4} />
                )}
                {showImageBadges && imageBadges && (
                    <ProductImageBadges badgeList={imageBadges} maxBadges={maximumNumberOfImageBadges ?? 4} />
                )}
                {showProductAvailability && (
                    <StyledWrapper>
                        <AHRIRelatedProductContextAvailability product={product} productInfo={productInfo} extendedStyles={styles.availabilityStyles} />
                    </StyledWrapper>
                )}
                {showPrice && (
                    <StyledWrapper {...styles.productPriceWrapper}>
                        <VisuallyHidden as="label" htmlFor="ahri-relatedProduct-uom" id="ahri-relatedProduct-uom-label">
                            {translate("U/M")}
                        </VisuallyHidden>
                        <ProductPrice
                            extendedStyles={styles.productPriceStyles}
                            showLabel={false}
                            product={productContext}
                        />
                        {product.unitOfMeasures && (
                            <AHRIRelatedProductUnitOfMeasureSelect
                                productContext={productContext}
                                labelOverride=""
                                extendedStyles={styles.productUnitOfMeasureSelectStyles}
                                id="ahri-relatedProduct-uom"
                            />
                        )}
                        <AHRIRelatedProductQuantityBreakPricing product={product} productInfo={productInfo} extendedStyles={styles.productQuantityBreakPricingStyles}/>
                    </StyledWrapper>
                )}

                {showAddToCart && (
                    <GridContainer {...styles.addToCartContainer}>
                        <GridItem {...styles.qtyGridItem}>
                            <VisuallyHidden as="label" htmlFor="ahri-relatedProduct-qty" id="ahri-relatedProduct-qty-label">
                                {translate("QTY")}
                            </VisuallyHidden>
                            <AHRIRelatedProductQuantityOrdered
                                labelOverride=""
                                extendedStyles={styles.productQuantityOrderedStyles}
                                id="ahri-relatedProduct-qty"
                                productContext={productContext}
                            />
                        </GridItem>
                        <GridItem {...styles.addToCartButtonGridItem}>
                            <AHRIRelatedProductAddToCartButton
                                data-test-selector="addToCartBtn"
                                extendedStyles={styles.productAddToCartButtonStyles}
                                productContext={productContext}
                            />
                        </GridItem>
                    </GridContainer>
                )}
                {showAddToList && (
                    <AHRIRelatedProductAddToListLink
                        data-test-selector="addToListLink"
                        extendedStyles={styles.productAddToListLinkStyles}
                        productContext={productContext}
                    />
                )}
        </>
    )
}

export default connect(mapStateToProps, mapDispatchToProps)(AHRIToolRelatedProductInfo);